import dayjs from "dayjs";

export const formatBytes = (bytes: number, decimals: number = 2): string => {
	if (bytes === 0) {
		return '0 Bytes';
	}

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const formatDuration = (seconds: number): string => {
	if (seconds) {
		const minutes = Math.floor(seconds / 60);
		const remainder = seconds - (minutes * 60);
		const newSeconds = Math.round(remainder);

		return `${minutes.toString().padStart(2, '0')}:${newSeconds.toString().padStart(2, '0')}`;
	}

	return '00:00';
};

export const formatNumber = (num: number, decimals?: number): string => {
	if (decimals) {
		return num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatDate = (dt: Date | string | dayjs.Dayjs | null | undefined, format: string = 'MM/DD/YYYY'): string => {
	if (dt === null || dt === undefined) {
		return '';
	}

	return dayjs(dt).format(format);
}

export const formatDateUTC = (dt: Date | string | dayjs.Dayjs | null | undefined, format: string = 'MM/DD/YYYY'): string => {
	if (dt === null || dt === undefined) {
		return '';
	}

	return dayjs.utc(dt).format(format);
}
